import React from 'react';
import ReactDOM from 'react-dom/client';
import './the-worship-bible.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Navigation from "./components/general/Navigation";
import SimpleFooter from "./components/general/SimpleFooter";
import {Col, Row} from "reactstrap";
import CookieConsent from "react-cookie-consent";
import {AuthProvider} from "./components/helpers/AuthContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <AuthProvider>
          <CookieConsent buttonText="Accept"
                         style={{ background: "#7795f8" }}
                         buttonStyle={{ background: "#FFFFFF", color: "#7795f8" }}>
              <div>
                  <Row className="justify-content-center">
                      <p className="description mt-3">
                          <img src={require("./assets/images/termly-logo.png")} alt="Termly"/>
                      </p>
                  </Row>
                  <Row>
                      <Col className="description mt-3">
                          We use essential cookies to make our site work.
                          With your consent, we may also use non-essential cookies to improve user experience and analyze website
                          traffic. By clicking “Accept”, you agree to our website's cookie use as described in our&nbsp;
                          <span role="link" tabIndex="0"><a href="/cookie-policy" className="text-white">Cookie Policy</a></span>.
                      </Col>
                  </Row>
              </div>
          </CookieConsent>
          <Navigation/>
          <App />
          <SimpleFooter/>
      </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/* ================================
   PWA Service Worker Registration
================================= */
if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
        for (let registration of registrations) {
            registration.unregister();
        }
    });
}